import { CompletedState, ErrorState, FileUploadStatusCode, PollingState } from './Setup.types';

const ERROR_STATES = [
  FileUploadStatusCode.ERROR,
  FileUploadStatusCode.PARTIAL_FAILURE,
  FileUploadStatusCode.FAILED,
] as const;

const POLLING_STATES = [FileUploadStatusCode.WAITING, FileUploadStatusCode.PROCESSING] as const;

const COMPLETED_STATES = [
  FileUploadStatusCode.SUCCESS,
  FileUploadStatusCode.PARTIAL_FAILURE,
  FileUploadStatusCode.FAILED,
  FileUploadStatusCode.ERROR,
] as const;

export const isErrorState = (state?: FileUploadStatusCode): state is ErrorState =>
  state !== undefined && (ERROR_STATES as readonly FileUploadStatusCode[]).includes(state);

export const isPollingState = (state?: FileUploadStatusCode): state is PollingState =>
  state !== undefined && (POLLING_STATES as readonly FileUploadStatusCode[]).includes(state);

export const isCompletedState = (state?: FileUploadStatusCode): state is CompletedState =>
  state !== undefined && (COMPLETED_STATES as readonly FileUploadStatusCode[]).includes(state);
